import env from 'env';
import ReactDOM from 'react-dom/client';

export const resizeSearchalityWidget = (
  iframeDocument: Document,
  iframe: HTMLIFrameElement,
) => {
  const bodyChild = iframeDocument?.body?.querySelector('div');

  if (!bodyChild || !bodyChild.scrollHeight) return;

  iframe.style.height = `${bodyChild.scrollHeight + 40}px`;
};

export const createWidgetIframe = () => {
  const iframe = document.createElement('iframe');
  iframe.style.width = '100%';
  iframe.frameBorder = '0';
  iframe.title = 'Searchality Widget';
  iframe.id = 'searchality-iframe';
  iframe.src = 'about:blank';

  return iframe;
};

export const initWidget = (iframe: HTMLIFrameElement) => {
  const iframeDocument =
    iframe.contentDocument || iframe.contentWindow.document;

  createResizeObserver(iframeDocument, iframe);

  let cssLink = document.getElementById(
    'searchality-widget-css',
  ) as HTMLLinkElement;

  if (!cssLink) {
    cssLink = createLinkElement();
  }

  cssLink.addEventListener('load', () => {
    requestAnimationFrame(() => resizeSearchalityWidget(iframeDocument, iframe));
  }, { once: true });

  iframeDocument.head.appendChild(cssLink);

  return ReactDOM.createRoot(iframeDocument.body);
};

export const createResizeObserver = (
  iframeDocument: Document,
  iframe: HTMLIFrameElement,
) => {
  const resize = () => {
    requestAnimationFrame(() => resizeSearchalityWidget(iframeDocument, iframe));
  };

  const mutationObserver = new MutationObserver(resize);

  mutationObserver.observe(iframeDocument.body, {
    childList: true,
    subtree: true,
    attributes: true,
  });
};

export const createLinkElement = () => {
  const cssLink = document.createElement('link');
  cssLink.href = `${env.WIDGET_ENDPOINT}/main.css`;
  cssLink.rel = 'stylesheet';

  return cssLink;
};
